export const translations = {
  tr: {
    translation: {
      nav: {
        home: "Ana Sayfa",
        services: "Hizmetler",
        packages: "Paketler",
        about: "Hakkımızda",
        portfolio: "Portfolyo",
        blog: "Blog",
        contact: "İletişim"
      },
      hero: {
        title: "Kazanmak İstiyorsan Doğru Ekiple Yürümek Gerekir.",
        subtitle: "Biz Hazırız: Tecrübe, hız ve sonuç.",
        cta: "Hemen Başlayın",
        packages: "Paketleri İncele",
        badge: "Dijital Dönüşümün Lideri",
        stats: {
          clients: "Mutlu Müşteri",
          projects: "Proje",
          experience: "Yıl Deneyim"
        }
      },
      trustBanner: {
        title: "Bize Güvenen 70'den Fazla Müşteri",
        subtitle: "Başarılı bir işletme kurmak zor değil. Müşterilerimizin deneyimlerini keşfedin.",
        button: "Referanslarımız"
      },
      socialStats: {
        title: "Sosyal Medyada Takipçilerimiz",
        subtitle: "Bizi sosyal medyada takip edin ve içeriklerimizi keşfedin",
        followers: "Takipçi",
        likes: "Beğeni",
        followUs: "Takip Et",
        note: "Takipçi sayıları anlık olarak güncellenmektedir"
      },
      videoShowcase: {
        title: "Tanıtım Videolarımız",
        subtitle: "Profesyonel video prodüksiyon örneklerimiz",
        ai: "Yapay Zeka Destekli"
      },
      services: {
        title: "Hizmetlerimiz",
        subtitle: "İşletmenizi dijital dünyada öne çıkaracak kapsamlı çözümler",
        social: {
          title: "Sosyal Medya Yönetimi",
          desc: "Instagram, TikTok, LinkedIn, YouTube ve tüm platformlarda profesyonel içerik üretimi ve hesap yönetimi."
        },
        ecommerce: {
          title: "E-Ticaret Kurulum & Yönetimi",
          desc: "Trendyol, Hepsiburada, N11, Amazon TR ve tüm Türkiye pazaryerlerinde mağaza kurulum ve yönetimi."
        },
        ads: {
          title: "Reklam Prodüksiyonu",
          desc: "Profesyonel video ve fotoğraf çekimleri ile markanızı en iyi şekilde tanıtın.",
          features: {
            video: "Video Prodüksiyon",
            photo: "Fotoğraf Çekimi",
            drone: "Drone Çekimi",
            studio: "Stüdyo Hizmeti",
            post: "Post Prodüksiyon",
            animation: "Animasyon"
          }
        },
        models: {
          title: "Model Seçenekleri",
          desc: "Farklı dillerde konuşan ve çeşitli profillerde modellerle reklam çekimi imkanı.",
          features: {
            turkish: "Türkçe Konuşan",
            english: "İngilizce Konuşan",
            german: "Almanca Konuşan",
            russian: "Rusça Konuşan",
            arabic: "Arapça Konuşan",
            other: "Diğer Diller"
          }
        },
        cta: "Teklif Al",
        options: "seçenek"
      },
      packages: {
        title: "Fiyatlandırma",
        subtitle: "İhtiyaçlarınıza uygun paketi seçin",
        monthly: "/ ay",
        moreDetails: "+ Daha Fazlası",
        detailedTitle: "Detaylı Paket Karşılaştırması",
        detailedSubtitle: "Tüm paket özelliklerini detaylı inceleyin",
        ecommerce: {
          name: "E-Ticaret",
          price: "55.000 ₺",
          features: [
            "Trendyol, Hepsiburada, N11 Mağaza Yönetimi",
            "Ürün Fotoğraf & Açıklama Optimizasyonu",
            "E-Ticaret SEO",
            "Aylık Satış Raporu",
            "Google Ads & Meta Reklam"
          ],
          detailedFeatures: [
            "Trendyol, Hepsiburada, N11 Mağaza Kurulum & Yönetimi",
            "Ürün Fotoğraf Çekimi & Açıklama Optimizasyonu",
            "E-Ticaret SEO Ayarlaması",
            "Google Ads Ayarlamaları",
            "Meta Reklam Ayarlamaları",
            "Aylık Satış & Performans Raporu",
            "Ürün Listeleme & Katalog Yönetimi",
            "Fiyatlandırma Stratejisi",
            "Stok Takip & Yönetimi",
            "Çalışma Saatlerinde Geri Dönüş (10:00-18:00)",
            "Kriz İletişimi Yönetimi"
          ],
          cta: "Paketi Seç"
        },
        starter: {
          name: "Başlangıç",
          price: "70.000 ₺",
          features: [
            "2 Platform (Instagram + TikTok)",
            "Aylık 24 Video İçerik",
            "Tanıtım Web Sitesi",
            "Otomatik Model Seçimi",
            "Google Ads & Meta Reklam"
          ],
          detailedFeatures: [
            "2 Sosyal Medya Platformu (Instagram + TikTok)",
            "Aylık 24 Video İçerik (Reels/Shorts)",
            "Tanıtım Web Sitesi",
            "Otomatik Model Seçimi",
            "Çalışma Saatlerinde Geri Dönüş (10:00-18:00)",
            "Google Ads Ayarlamaları",
            "Meta Reklam Ayarlamaları",
            "SEO Ayarlaması",
            "Aylık Performans Raporu",
            "Temel İçerik Planlaması",
            "İçerik Takvimi",
            "Ayda 1 Liderle Müşteri Kazanma Görüşmesi (Uzaktan)",
            "Kriz İletişimi Yönetimi"
          ],
          cta: "Paketi Seç"
        },
        professional: {
          name: "Profesyonel",
          price: "99.000 ₺",
          popular: "En Popüler",
          features: [
            "3 Platform (Instagram + TikTok + X)",
            "Aylık 48 Video İçerik",
            "Kurumsal E-Ticaret + Tanıtım Web Sitesi",
            "Aylık 1 Tanıtım Videosu",
            "2 Model Seçme Hakkı"
          ],
          detailedFeatures: [
            "3 Sosyal Medya Platformu (Instagram, TikTok, X)",
            "Aylık 48 Video İçerik (Reels/Shorts)",
            "Kurumsal E-Ticaret + Tanıtım Web Sitesi",
            "Ayda 1 Büyük Tanıtım Videosu",
            "2 Model Seçme Hakkı",
            "Çalışma Saatleri +2 Saat Destek (10:00-20:00)",
            "Hashtag Araştırması (3 Ayda Bir)",
            "Google Ads Ayarlamaları",
            "Meta Reklam Ayarlamaları",
            "SEO Ayarlaması",
            "3 Ayda Bir Performans Raporu",
            "Gelişmiş İçerik Stratejisi",
            "Özel Görsel Tasarımlar",
            "3 Ayda Bir Strateji Toplantısı",
            "Yıllık Marka Planlaması",
            "Haftada 1 Liderle Müşteri Kazanma Görüşmesi (Uzaktan)",
            "Ayda 1 E-Ticaret Satış Eğitimi (Liderden)",
            "Kriz İletişimi Yönetimi"
          ],
          cta: "Paketi Seç"
        },
        fenomen: {
          name: "Fenomen",
          price: "150.000 ₺",
          features: [
            "5 Platform (YouTube, Instagram, X, TikTok, LinkedIn)",
            "Aylık 96 Video İçerik",
            "Kurumsal Web Sitesi + E-Ticaret",
            "Aylık 5 Tanıtım Videosu",
            "İstediğiniz Model + Dil Seçenekleri"
          ],
          detailedFeatures: [
            "5 Sosyal Medya Platformu (YouTube, Instagram, X, TikTok, LinkedIn)",
            "Aylık 96 Video İçerik (Reels/Shorts)",
            "Kurumsal Web Sitesi + E-Ticaret Sitesi",
            "Ayda 5 Büyük Tanıtım Videosu",
            "İstediğiniz Model + Dil Seçenekleri",
            "7/24 VIP Destek",
            "Hashtag Araştırması (Her Ay)",
            "Rakip Analizi (Her Ay)",
            "Google Ads Ayarlamaları",
            "Meta Reklam Ayarlamaları",
            "SEO Ayarlaması",
            "Özel Proje Yöneticisi",
            "Kişisel Marka Danışmanlığı",
            "Influencer Strateji Planlaması",
            "Aylık Strateji Toplantısı",
            "Yıllık Marka Planlaması",
            "Çalışma Saatlerinde İstediğiniz Zaman Liderle Görüşme (Uzaktan)",
            "Haftada 1 E-Ticaret Satış Eğitimi (Liderden)",
            "Özel Etkinlik Desteği",
            "Kriz İletişimi Yönetimi"
          ],
          cta: "Paketi Seç"
        },
        enterprise: {
          name: "Kurumsal",
          price: "Özel Fiyat",
          features: [
            "4 Platform (YouTube, Instagram, X, TikTok)",
            "Aylık 72 Video İçerik",
            "E-Ticaret Sitesi + Özel E-Ticaret Sitesi",
            "Aylık 3 Tanıtım Videosu",
            "İstediğiniz Model + Dil Seçenekleri"
          ],
          detailedFeatures: [
            "4 Sosyal Medya Platformu (YouTube, Instagram, X, TikTok)",
            "Aylık 72 Video İçerik (Reels/Shorts)",
            "E-Ticaret Sitesi + Özel E-Ticaret Sitesi",
            "Ayda 3 Büyük Tanıtım Videosu",
            "İstediğiniz Model + Dil Seçenekleri",
            "7/24 Destek",
            "Hashtag Araştırması (Her Ay)",
            "Rakip Analizi (Her Ay)",
            "Google Ads Ayarlamaları",
            "Meta Reklam Ayarlamaları",
            "SEO Ayarlaması",
            "Özel Proje Yöneticisi",
            "Marka Stratejisi Danışmanlığı",
            "360° Dijital Pazarlama",
            "VIP Müşteri Desteği",
            "Aylık Strateji Toplantısı",
            "3 Ayda Bir Marka Planlaması",
            "Çalışma Saatlerinde İstediğiniz Zaman Liderle Görüşme (Uzaktan)",
            "Haftada 1 E-Ticaret Satış Eğitimi (Liderden)",
            "Özel Etkinlik Desteği",
            "Kriz İletişimi Yönetimi"
          ],
          cta: "İletişime Geç"
        }
      },
      about: {
        title: "Hakkımızda",
        tagline: "Büyüme, Netlik ve Sürdürülebilir Başarı",
        intro: "Usta Consulting, büyüme, netlik ve sürdürülebilir başarıyı temsil eder. İşletmelerin potansiyellerini en üst düzeye çıkarmalarına yardımcı olan stratejik bir ortağız.",
        paragraph1: "5 yılı aşkın sektör deneyimimiz ve Türkiye, Almanya, Litvanya, Belçika, Hollanda gibi farklı ülkelerde 70'den fazla işletmeye sunduğumuz danışmanlık hizmetleriyle, her sektörün kendine özgü dinamiklerini çok iyi biliyoruz.",
        paragraph2: "Her işbirliğimizde, işletmelere özel çözümler sunuyor; analitik düşünce, yaratıcı strateji ve uzun vadeli başarı odaklı bir yaklaşımla hareket ediyoruz.",
        highlight1: "Satış ve pazarlama stratejileri",
        highlight2: "Dijitalleşme ve e-ticaret çözümleri",
        highlight3: "Kurumsal yönetim danışmanlığı",
        highlight4: "Sosyal medya ve marka yönetimi",
        vision: "Vizyonumuz",
        visionText: "Global ölçekte işletmelere rehberlik eden, yenilikçi ve sonuç odaklı danışmanlık hizmetleri sunan lider bir kuruluş olmak.",
        mission: "Misyonumuz",
        missionText: "Her ölçekteki işletmeye stratejik çözümler sunarak, sürdürülebilir büyüme ve kalıcı başarı elde etmelerini sağlamak.",
        closing: "Uzman ekibimiz; satış, pazarlama, dijitalleşme ve kurumsal yönetim alanlarındaki bilgi ve deneyimlerini sizinle paylaşmak, işletmenizi bir adım öteye taşımak için hazır.",
        slogan: "\"Danışmanlıkta ustalık, başarıda ortaklık.\"",
        stats: {
          clients: "Mutlu Müşteri",
          projects: "Başarılı Proje",
          countries: "Ülkede Hizmet",
          satisfaction: "Müşteri Memnuniyeti"
        }
      },
      portfolio: {
        title: "Portfolyomuz",
        subtitle: "Başarılı projelerimizden örnekler",
        viewProject: "Projeyi İncele",
        privacyNotice: "Müşteri isimleri KVKK ve GDPR kapsamında gizlenmiştir.",
        germanyClient: "Almanya'daki Müşterimiz",
        reviewsTitle: "Müşteri Yorumları",
        reviewsSubtitle: "70'den fazla mutlu müşterimizin görüşleri",
        projects: {
          crazymobel: {
            title: "Crazy Möbel Outlet",
            category: "E-Ticaret & Dijital Pazarlama",
            desc: "Mobilya sektöründe kapsamlı dijital dönüşüm ve e-ticaret çözümleri"
          },
          fablemont: {
            title: "Fablemont Mobilya",
            category: "E-Ticaret & Marka Yönetimi",
            desc: "Mobilya markası için dijital pazarlama ve online satış stratejileri"
          },
          hipotez: {
            title: "Hipotez International",
            category: "Kurumsal Danışmanlık & Dijital Çözümler",
            desc: "Uluslararası ölçekte kurumsal danışmanlık ve dijital dönüşüm hizmetleri"
          },
          vizeeurope: {
            title: "Vize Europe",
            category: "Vize Danışmanlık & Hizmetleri",
            desc: "Avrupa vizesi başvuru süreçleri ve profesyonel danışmanlık hizmetleri"
          }
        }
      },
      crazyMobel: {
        title: "Crazy Möbel Outlet",
        subtitle: "Almanya'daki müşterimiz için hazırladığımız dijital dönüşüm projesi",
        visitWebsite: "Web Sitesini Ziyaret Et",
        projectScope: "Proje Kapsamı",
        projectScopeDesc: "Crazy Möbel Outlet için kapsamlı bir dijital pazarlama stratejisi geliştirdik. E-ticaret altyapısından sosyal medya yönetimine, reklam prodüksiyonundan SEO çalışmalarına kadar tüm dijital süreçleri yönettik.",
        services: "Sunduğumuz Hizmetler",
        service1: "Sosyal Medya Yönetimi",
        service2: "E-Ticaret Entegrasyonu",
        service3: "Profesyonel Reklam Çekimleri",
        service4: "Google & Meta Reklam Yönetimi",
        results: "Elde Edilen Sonuçlar",
        resultsDesc: "Dijital pazarlama çalışmalarımız sonucunda online satışlarda %300 artış, sosyal medya takipçi sayısında %500 büyüme ve marka bilinirliğinde önemli artış sağladık.",
        videosTitle: "Almanya'daki Müşterimiz İçin Çektiğimiz Videolar",
        videosSubtitle: "Profesyonel ekibimizle hazırladığımız tanıtım videoları"
      },
      team: {
        title: "Ekibimiz",
        subtitle: "Başarının arkasındaki profesyonel ekip",
        modelsTitle: "Modellerimiz",
        ourTeam: "Ekibimiz",
        members: {
          m1: {
            name: "Mert Usta",
            role: "Kurucu & CEO",
            expertise: "Uzmanlık: İş Geliştirme, Dijital Pazarlama & Strateji"
          },
          m2: {
            name: "Dilara Yüksekcan",
            role: "Model",
            expertise: ""
          },
          m3: {
            name: "Polina Vladyka",
            role: "Model",
            expertise: ""
          },
          m4: {
            name: "Svenja Patruska",
            role: "Model",
            expertise: ""
          },
          m5: {
            name: "Veronika Kabilya",
            role: "Model",
            expertise: ""
          },
          m6: {
            name: "Caner Toptaş",
            role: "Yazılım Mühendisi",
            expertise: "Uzmanlık: Full-Stack Geliştirme, React, Django, Docker & Modern Web Teknolojileri"
          },
          m7: {
            name: "Ayça Ulutaş",
            role: "Model",
            expertise: ""
          }
        }
      },
      blog: {
        title: "Blog",
        subtitle: "Dijital dünyadan en güncel bilgiler",
        readMore: "Devamını Oku",
        allPosts: "Tüm Yazıları Gör",
        search: "Blog yazısı ara..."
      },
      contact: {
        title: "İletişim",
        subtitle: "Bizimle iletişime geçin",
        name: "Adınız",
        email: "E-posta",
        phone: "Telefon",
        message: "Mesajınız",
        send: "Gönder",
        info: "İletişim Bilgileri",
        address: "Adres",
        workingHours: "Çalışma Saatleri",
        followUs: "Bizi Takip Edin",
        whatsappBtn: "WhatsApp ile İletişime Geç"
      },
      footer: {
        rights: "Tüm hakları saklıdır.",
        privacy: "Gizlilik Politikası",
        terms: "Kullanım Şartları",
        desc: "Dijital dünyada başarınızın ortağı. Sosyal medya, e-ticaret ve reklam çözümleriyle markanızı zirveye taşıyoruz.",
        quickLinks: "Hızlı Linkler",
        services: "Hizmetler",
        socialMedia: "Sosyal Medya Yönetimi",
        ecommerce: "E-Ticaret Kurulum",
        adProduction: "Reklam Prodüksiyonu",
        modelOptions: "Model Seçenekleri",
        digitalConsulting: "Dijital Danışmanlık",
        location: "İstanbul, Türkiye"
      },
      privacy: {
        title: "Gizlilik Politikası",
        lastUpdated: "Son Güncelleme",
        section1: {
          title: "1. Toplanan Bilgiler",
          content: "UstaConsulting olarak, hizmetlerimizi sunabilmek için bazı kişisel bilgilerinizi topluyoruz. Bu bilgiler arasında ad, soyad, e-posta adresi, telefon numarası ve şirket bilgileri yer alabilir."
        },
        section2: {
          title: "2. Bilgilerin Kullanımı",
          content: "Topladığımız bilgileri hizmetlerimizi sağlamak, müşteri desteği sunmak, pazarlama iletişimleri göndermek ve hizmetlerimizi iyileştirmek amacıyla kullanıyoruz."
        },
        section3: {
          title: "3. Bilgi Güvenliği",
          content: "Kişisel bilgilerinizin güvenliğini sağlamak için endüstri standardı güvenlik önlemleri kullanıyoruz. Verileriniz şifreli bağlantılar üzerinden iletilir ve güvenli sunucularda saklanır."
        },
        section4: {
          title: "4. Çerezler",
          content: "Web sitemizde kullanıcı deneyimini iyileştirmek için çerezler kullanıyoruz. Tarayıcı ayarlarınızdan çerezleri devre dışı bırakabilirsiniz."
        },
        section5: {
          title: "5. Üçüncü Taraflar",
          content: "Kişisel bilgilerinizi yasal zorunluluklar dışında üçüncü taraflarla paylaşmıyoruz. Hizmet sağlayıcılarımız da aynı gizlilik standartlarına uymak zorundadır."
        },
        contact: {
          title: "6. İletişim",
          content: "Gizlilik politikamızla ilgili sorularınız için bizimle iletişime geçebilirsiniz:"
        }
      },
      terms: {
        title: "Kullanım Şartları",
        lastUpdated: "Son Güncelleme",
        section1: {
          title: "1. Hizmet Koşulları",
          content: "UstaConsulting hizmetlerini kullanarak bu kullanım şartlarını kabul etmiş olursunuz. Hizmetlerimiz ticari amaçlı dijital danışmanlık, sosyal medya yönetimi ve e-ticaret çözümlerini kapsar."
        },
        section2: {
          title: "2. Kullanıcı Sorumlulukları",
          content: "Kullanıcılar, hizmetlerimizi yasal amaçlar için kullanmayı ve doğru bilgi sağlamayı taahhüt eder. Yanıltıcı veya sahte bilgi verilmesi durumunda hizmet askıya alınabilir."
        },
        section3: {
          title: "3. Ödeme Koşulları",
          content: "Hizmet bedelleri sözleşmede belirtilen şekilde ve sürede ödenmelidir. Gecikmeli ödemelerde yasal faiz uygulanabilir."
        },
        section4: {
          title: "4. Fikri Mülkiyet",
          content: "Tüm içerikler, tasarımlar ve materyaller UstaConsulting'e aittir. İzinsiz kopyalama veya dağıtım yasaktır."
        },
        section5: {
          title: "5. Sorumluluk Sınırı",
          content: "UstaConsulting, hizmetlerin kesintisiz veya hatasız olacağını garanti etmez. Dolaylı zararlardan sorumlu tutulamaz."
        },
        contact: {
          title: "6. İletişim",
          content: "Kullanım şartlarıyla ilgili sorularınız için bizimle iletişime geçebilirsiniz:"
        }
      }
    }
  },
  en: {
    translation: {
      nav: {
        home: "Home",
        services: "Services",
        packages: "Packages",
        about: "About",
        portfolio: "Portfolio",
        blog: "Blog",
        contact: "Contact"
      },
      hero: {
        title: "Consulting Reimagined",
        subtitle: "Usta Consulting Helps You Gain New Customers And Supports Your Business Digitalization.",
        cta: "Get Started",
        packages: "View Packages",
        badge: "Leader in Digital Transformation",
        trustedBy: "Trusted by Over 70 Clients",
        stats: {
          clients: "Happy Clients",
          projects: "Projects",
          experience: "Years Experience"
        }
      },
      trustBanner: {
        title: "Trusted by Over 70 Clients",
        subtitle: "Building a successful business is not magic. Discover the experiences of our clients.",
        button: "Our References"
      },
      socialStats: {
        title: "Our Social Media Followers",
        subtitle: "Follow us on social media and discover our content",
        followers: "Followers",
        likes: "Likes",
        followUs: "Follow Us",
        note: "Follower counts are updated in real-time"
      },
      videoShowcase: {
        title: "Our Showcase Videos",
        subtitle: "Professional video production examples",
        ai: "AI Powered"
      },
      services: {
        title: "Our Services",
        subtitle: "Comprehensive solutions to make your business stand out in the digital world",
        social: {
          title: "Social Media Management",
          desc: "Professional content creation and account management on Instagram, TikTok, LinkedIn, YouTube, and all platforms."
        },
        ecommerce: {
          title: "E-Commerce Setup & Management",
          desc: "Store setup and management on Trendyol, Hepsiburada, N11, Amazon TR, and all Turkish marketplaces."
        },
        ads: {
          title: "Ad Production",
          desc: "Introduce your brand in the best way with professional video and photo shoots.",
          features: {
            video: "Video Production",
            photo: "Photo Shoot",
            drone: "Drone Shoot",
            studio: "Studio Service",
            post: "Post Production",
            animation: "Animation"
          }
        },
        models: {
          title: "Model Options",
          desc: "Advertising opportunities with models speaking different languages and various profiles.",
          features: {
            turkish: "Turkish Speaking",
            english: "English Speaking",
            german: "German Speaking",
            russian: "Russian Speaking",
            arabic: "Arabic Speaking",
            other: "Other Languages"
          }
        },
        cta: "Get a Quote",
        options: "options"
      },
      packages: {
        title: "Pricing",
        subtitle: "Choose the package that suits your needs",
        monthly: "/ month",
        moreDetails: "+ More Details",
        detailedTitle: "Detailed Package Comparison",
        detailedSubtitle: "Review all package features in detail",
        ecommerce: {
          name: "E-Commerce",
          price: "55,000 ₺",
          features: [
            "Trendyol, Hepsiburada, N11 Store Management",
            "Product Photo & Description Optimization",
            "E-Commerce SEO",
            "Monthly Sales Report",
            "Google Ads & Meta Ads"
          ],
          detailedFeatures: [
            "Trendyol, Hepsiburada, N11 Store Setup & Management",
            "Product Photography & Description Optimization",
            "E-Commerce SEO Setup",
            "Google Ads Setup",
            "Meta Ads Setup",
            "Monthly Sales & Performance Report",
            "Product Listing & Catalog Management",
            "Pricing Strategy",
            "Stock Tracking & Management",
            "Business Hours Support (10:00-18:00)",
            "Crisis Communication Management"
          ],
          cta: "Select Package"
        },
        starter: {
          name: "Starter",
          price: "70,000 ₺",
          features: [
            "2 Platforms (Instagram + TikTok)",
            "24 Monthly Video Content",
            "Promotional Website",
            "Automatic Model Selection",
            "Google Ads & Meta Ads"
          ],
          detailedFeatures: [
            "2 Social Media Platforms (Instagram + TikTok)",
            "24 Monthly Video Content (Reels/Shorts)",
            "Promotional Website",
            "Automatic Model Selection",
            "Business Hours Support (10:00-18:00)",
            "Google Ads Setup",
            "Meta Ads Setup",
            "SEO Setup",
            "Monthly Performance Report",
            "Basic Content Planning",
            "Content Calendar",
            "Monthly Customer Acquisition Call with Leader (Remote)",
            "Crisis Communication Management"
          ],
          cta: "Select Package"
        },
        professional: {
          name: "Professional",
          price: "99,000 ₺",
          popular: "Most Popular",
          features: [
            "3 Platforms (Instagram + TikTok + X)",
            "48 Monthly Video Content",
            "Corporate E-Commerce + Promotional Website",
            "1 Promo Video per Month",
            "2 Model Selection Rights"
          ],
          detailedFeatures: [
            "3 Social Media Platforms (Instagram, TikTok, X)",
            "48 Monthly Video Content (Reels/Shorts)",
            "Corporate E-Commerce + Promotional Website",
            "1 Major Promo Video per Month",
            "2 Model Selection Rights",
            "Extended Support Hours (10:00-20:00)",
            "Hashtag Research (Every 3 Months)",
            "Google Ads Setup",
            "Meta Ads Setup",
            "SEO Setup",
            "Quarterly Performance Reports",
            "Advanced Content Strategy",
            "Custom Visual Designs",
            "Quarterly Strategy Meeting",
            "Annual Brand Planning",
            "Weekly Customer Acquisition Call with Leader (Remote)",
            "Monthly E-Commerce Sales Training (From Leader)",
            "Crisis Communication Management"
          ],
          cta: "Select Package"
        },
        fenomen: {
          name: "Influencer",
          price: "150,000 ₺",
          features: [
            "5 Platforms (YouTube, Instagram, X, TikTok, LinkedIn)",
            "96 Monthly Video Content",
            "Corporate Website + E-Commerce",
            "5 Promo Videos per Month",
            "Any Model + Language Options"
          ],
          detailedFeatures: [
            "5 Social Media Platforms (YouTube, Instagram, X, TikTok, LinkedIn)",
            "96 Monthly Video Content (Reels/Shorts)",
            "Corporate Website + E-Commerce Site",
            "5 Major Promo Videos per Month",
            "Any Model + Language Options",
            "24/7 VIP Support",
            "Hashtag Research (Monthly)",
            "Competitor Analysis (Monthly)",
            "Google Ads Setup",
            "Meta Ads Setup",
            "SEO Setup",
            "Dedicated Project Manager",
            "Personal Brand Consulting",
            "Influencer Strategy Planning",
            "Monthly Strategy Meeting",
            "Annual Brand Planning",
            "Leader Call Anytime During Business Hours (Remote)",
            "Weekly E-Commerce Sales Training (From Leader)",
            "Special Event Support",
            "Crisis Communication Management"
          ],
          cta: "Select Package"
        },
        enterprise: {
          name: "Enterprise",
          price: "Custom Price",
          features: [
            "4 Platforms (YouTube, Instagram, X, TikTok)",
            "72 Monthly Video Content",
            "E-Commerce Site + Custom E-Commerce Site",
            "3 Promo Videos per Month",
            "Any Model + Language Options"
          ],
          detailedFeatures: [
            "4 Social Media Platforms (YouTube, Instagram, X, TikTok)",
            "72 Monthly Video Content (Reels/Shorts)",
            "E-Commerce Site + Custom E-Commerce Site",
            "3 Major Promo Videos per Month",
            "Any Model + Language Options",
            "24/7 Support",
            "Hashtag Research (Monthly)",
            "Competitor Analysis (Monthly)",
            "Google Ads Setup",
            "Meta Ads Setup",
            "SEO Setup",
            "Dedicated Project Manager",
            "Brand Strategy Consulting",
            "360° Digital Marketing",
            "VIP Customer Support",
            "Monthly Strategy Meeting",
            "Quarterly Brand Planning",
            "Leader Call Anytime During Business Hours (Remote)",
            "Weekly E-Commerce Sales Training (From Leader)",
            "Special Event Support",
            "Crisis Communication Management"
          ],
          cta: "Contact Us"
        }
      },
      about: {
        title: "About Us",
        tagline: "Growth, Clarity and Sustainable Success",
        intro: "Usta Consulting represents growth, clarity and sustainable success. We are a strategic partner helping businesses maximize their potential.",
        paragraph1: "With over 5 years of industry experience and consulting services provided to more than 70 businesses across different countries including Turkey, Germany, Lithuania, Belgium, and the Netherlands, we deeply understand the unique dynamics of each sector.",
        paragraph2: "In every collaboration, we offer tailored solutions for businesses; acting with an approach focused on analytical thinking, creative strategy, and long-term success.",
        highlight1: "Sales and marketing strategies",
        highlight2: "Digitalization and e-commerce solutions",
        highlight3: "Corporate management consulting",
        highlight4: "Social media and brand management",
        vision: "Our Vision",
        visionText: "To be a leading organization that guides businesses on a global scale, offering innovative and results-oriented consulting services.",
        mission: "Our Mission",
        missionText: "To provide strategic solutions to businesses of all sizes, enabling them to achieve sustainable growth and lasting success.",
        closing: "Our expert team is ready to share their knowledge and experience in sales, marketing, digitalization, and corporate management to take your business to the next level.",
        slogan: "\"Mastery in consulting, partnership in success.\"",
        stats: {
          clients: "Happy Clients",
          projects: "Successful Projects",
          countries: "Countries Served",
          satisfaction: "Client Satisfaction"
        }
      },
      portfolio: {
        title: "Our Portfolio",
        subtitle: "Examples of our successful projects",
        viewProject: "View Project",
        privacyNotice: "Customer names are hidden in accordance with KVKK and GDPR.",
        germanyClient: "Our Client in Germany",
        reviewsTitle: "Customer Reviews",
        reviewsSubtitle: "Opinions from our 70+ happy customers",
        projects: {
          crazymobel: {
            title: "Crazy Möbel Outlet",
            category: "E-Commerce & Digital Marketing",
            desc: "Comprehensive digital transformation and e-commerce solutions in the furniture industry"
          },
          fablemont: {
            title: "Fablemont Furniture",
            category: "E-Commerce & Brand Management",
            desc: "Digital marketing and online sales strategies for furniture brand"
          },
          hipotez: {
            title: "Hipotez International",
            category: "Corporate Consulting & Digital Solutions",
            desc: "International corporate consulting and digital transformation services"
          },
          vizeeurope: {
            title: "Vize Europe",
            category: "Visa Consulting & Services",
            desc: "European visa application processes and professional consulting services"
          }
        }
      },
      crazyMobel: {
        title: "Crazy Möbel Outlet",
        subtitle: "Digital transformation project we prepared for our client in Germany",
        visitWebsite: "Visit Website",
        projectScope: "Project Scope",
        projectScopeDesc: "We developed a comprehensive digital marketing strategy for Crazy Möbel Outlet. We managed all digital processes from e-commerce infrastructure to social media management, from ad production to SEO work.",
        services: "Services We Provided",
        service1: "Social Media Management",
        service2: "E-Commerce Integration",
        service3: "Professional Ad Production",
        service4: "Google & Meta Ads Management",
        results: "Results Achieved",
        resultsDesc: "As a result of our digital marketing efforts, we achieved a 300% increase in online sales, 500% growth in social media followers and a significant increase in brand awareness.",
        videosTitle: "Videos We Shot for Our Client in Germany",
        videosSubtitle: "Promotional videos prepared by our professional team"
      },
      team: {
        title: "Our Team",
        subtitle: "The professional team behind our success",
        modelsTitle: "Our Models",
        ourTeam: "Our Team",
        members: {
          m1: {
            name: "Mert Usta",
            role: "Founder & CEO",
            expertise: "Expertise: Business Development, Digital Marketing & Strategy"
          },
          m2: {
            name: "Dilara Yüksekcan",
            role: "Model",
            expertise: ""
          },
          m3: {
            name: "Polina Vladyka",
            role: "Model",
            expertise: ""
          },
          m4: {
            name: "Svenja Patruska",
            role: "Model",
            expertise: ""
          },
          m5: {
            name: "Veronika Kabilya",
            role: "Model",
            expertise: ""
          },
          m6: {
            name: "Caner Toptaş",
            role: "Software Engineer",
            expertise: "Expertise: Full-Stack Development, React, Django, Docker & Modern Web Technologies"
          },
          m7: {
            name: "Ayça Ulutaş",
            role: "Model",
            expertise: ""
          }
        }
      },
      blog: {
        title: "Blog",
        subtitle: "Latest news from the digital world",
        readMore: "Read More",
        allPosts: "View All Posts",
        search: "Search blog posts..."
      },
      contact: {
        title: "Contact",
        subtitle: "Get in touch with us",
        name: "Your Name",
        email: "Email",
        phone: "Phone",
        message: "Your Message",
        send: "Send",
        info: "Contact Information",
        address: "Address",
        workingHours: "Working Hours",
        followUs: "Follow Us",
        whatsappBtn: "Contact via WhatsApp"
      },
      footer: {
        rights: "All rights reserved.",
        privacy: "Privacy Policy",
        terms: "Terms of Use",
        desc: "Your partner in digital success. We take your brand to the top with social media, e-commerce and advertising solutions.",
        quickLinks: "Quick Links",
        services: "Services",
        socialMedia: "Social Media Management",
        ecommerce: "E-Commerce Setup",
        adProduction: "Ad Production",
        modelOptions: "Model Options",
        digitalConsulting: "Digital Consulting",
        location: "Istanbul, Turkey"
      },
      privacy: {
        title: "Privacy Policy",
        lastUpdated: "Last Updated",
        section1: {
          title: "1. Information Collected",
          content: "As UstaConsulting, we collect certain personal information to provide our services. This information may include name, surname, email address, phone number, and company information."
        },
        section2: {
          title: "2. Use of Information",
          content: "We use the information we collect to provide our services, offer customer support, send marketing communications, and improve our services."
        },
        section3: {
          title: "3. Information Security",
          content: "We use industry-standard security measures to ensure the security of your personal information. Your data is transmitted over encrypted connections and stored on secure servers."
        },
        section4: {
          title: "4. Cookies",
          content: "We use cookies on our website to improve user experience. You can disable cookies from your browser settings."
        },
        section5: {
          title: "5. Third Parties",
          content: "We do not share your personal information with third parties except for legal obligations. Our service providers must also comply with the same privacy standards."
        },
        contact: {
          title: "6. Contact",
          content: "For questions about our privacy policy, you can contact us:"
        }
      },
      terms: {
        title: "Terms of Use",
        lastUpdated: "Last Updated",
        section1: {
          title: "1. Service Terms",
          content: "By using UstaConsulting services, you agree to these terms of use. Our services include digital consulting, social media management, and e-commerce solutions for commercial purposes."
        },
        section2: {
          title: "2. User Responsibilities",
          content: "Users agree to use our services for legal purposes and to provide accurate information. Service may be suspended in case of misleading or false information."
        },
        section3: {
          title: "3. Payment Terms",
          content: "Service fees must be paid as specified in the contract and within the specified time. Legal interest may be applied for late payments."
        },
        section4: {
          title: "4. Intellectual Property",
          content: "All content, designs, and materials belong to UstaConsulting. Unauthorized copying or distribution is prohibited."
        },
        section5: {
          title: "5. Limitation of Liability",
          content: "UstaConsulting does not guarantee that services will be uninterrupted or error-free. We cannot be held responsible for indirect damages."
        },
        contact: {
          title: "6. Contact",
          content: "For questions about terms of use, you can contact us:"
        }
      }
    }
  },
  de: {
    translation: {
      nav: {
        home: "Startseite",
        services: "Dienstleistungen",
        packages: "Pakete",
        about: "Über uns",
        portfolio: "Portfolio",
        blog: "Blog",
        contact: "Kontakt"
      },
      hero: {
        title: "Beratung Neu Gedacht",
        subtitle: "Usta Consulting Hilft Ihnen, Neue Kunden Zu Gewinnen Und Unterstützt Die Digitalisierung Ihres Unternehmens.",
        cta: "Jetzt starten",
        packages: "Pakete ansehen",
        badge: "Führend in der digitalen Transformation",
        trustedBy: "Über 70 Kunden Vertrauen Uns",
        stats: {
          clients: "Zufriedene Kunden",
          projects: "Projekte",
          experience: "Jahre Erfahrung"
        }
      },
      trustBanner: {
        title: "Über 70 Kunden Vertrauen Uns Bereits",
        subtitle: "Ein erfolgreiches Unternehmen aufzubauen ist keine Hexerei. Entdecken Sie die Erfahrungen unserer Kunden.",
        button: "Unsere Referenzen"
      },
      socialStats: {
        title: "Unsere Social-Media-Follower",
        subtitle: "Folgen Sie uns in den sozialen Medien und entdecken Sie unsere Inhalte",
        followers: "Follower",
        likes: "Likes",
        followUs: "Folgen",
        note: "Follower-Zahlen werden in Echtzeit aktualisiert"
      },
      videoShowcase: {
        title: "Unsere Showcase-Videos",
        subtitle: "Professionelle Videoproduktionsbeispiele",
        ai: "KI-gestützt"
      },
      services: {
        title: "Unsere Dienstleistungen",
        subtitle: "Umfassende Lösungen, um Ihr Unternehmen in der digitalen Welt hervorzuheben",
        social: {
          title: "Social Media Management",
          desc: "Professionelle Inhaltserstellung und Kontoverwaltung auf Instagram, TikTok, LinkedIn, YouTube und allen Plattformen."
        },
        ecommerce: {
          title: "E-Commerce Einrichtung & Verwaltung",
          desc: "Shop-Einrichtung und Verwaltung auf Trendyol, Hepsiburada, N11, Amazon TR und allen türkischen Marktplätzen."
        },
        ads: {
          title: "Werbeproduktion",
          desc: "Präsentieren Sie Ihre Marke optimal mit professionellen Video- und Fotoaufnahmen.",
          features: {
            video: "Videoproduktion",
            photo: "Fotoshooting",
            drone: "Drohnenaufnahmen",
            studio: "Studioservice",
            post: "Postproduktion",
            animation: "Animation"
          }
        },
        models: {
          title: "Model-Optionen",
          desc: "Werbemöglichkeiten mit Models, die verschiedene Sprachen sprechen und unterschiedliche Profile haben.",
          features: {
            turkish: "Türkischsprachig",
            english: "Englischsprachig",
            german: "Deutschsprachig",
            russian: "Russischsprachig",
            arabic: "Arabischsprachig",
            other: "Andere Sprachen"
          }
        },
        cta: "Angebot anfordern",
        options: "Optionen"
      },
      packages: {
        title: "Preise",
        subtitle: "Wählen Sie das Paket, das Ihren Bedürfnissen entspricht",
        monthly: "/ Monat",
        moreDetails: "+ Mehr Details",
        detailedTitle: "Detaillierter Paketvergleich",
        detailedSubtitle: "Überprüfen Sie alle Paketfunktionen im Detail",
        ecommerce: {
          name: "E-Commerce",
          price: "55.000 ₺",
          features: [
            "Trendyol, Hepsiburada, N11 Shop-Verwaltung",
            "Produktfoto & Beschreibungsoptimierung",
            "E-Commerce SEO",
            "Monatlicher Verkaufsbericht",
            "Google Ads & Meta Ads"
          ],
          detailedFeatures: [
            "Trendyol, Hepsiburada, N11 Shop-Einrichtung & Verwaltung",
            "Produktfotografie & Beschreibungsoptimierung",
            "E-Commerce SEO-Einrichtung",
            "Google Ads Management",
            "Meta-Werbung Management",
            "Monatlicher Verkaufs- & Leistungsbericht",
            "Produktlistung & Katalogverwaltung",
            "Preisstrategie",
            "Bestandsverfolgung & Verwaltung",
            "Support während der Geschäftszeiten (10:00-18:00)",
            "Krisenkommunikationsmanagement"
          ],
          cta: "Paket wählen"
        },
        starter: {
          name: "Starter",
          price: "70.000 ₺",
          features: [
            "2 Plattformen (Instagram + TikTok)",
            "24 Videos pro Monat",
            "Werbe-Website",
            "Automatische Modelauswahl",
            "Google Ads & Meta Ads"
          ],
          detailedFeatures: [
            "2 Social-Media-Plattformen (Instagram + TikTok)",
            "24 Videos pro Monat",
            "Werbe-Website-Erstellung",
            "Automatische Modelauswahl",
            "Support während der Geschäftszeiten",
            "Google Ads Management",
            "Meta-Werbung Management",
            "SEO-Einstellungen",
            "Monatlicher Leistungsbericht",
            "Hashtag-Recherche",
            "Inhaltskalender",
            "Monatliches Kundengewinnungsgespräch mit Leader (Remote)",
            "Krisenkommunikationsmanagement"
          ],
          cta: "Paket wählen"
        },
        professional: {
          name: "Professionell",
          price: "99.000 ₺",
          popular: "Am beliebtesten",
          features: [
            "3 Plattformen (Instagram + TikTok + X)",
            "48 Videos pro Monat",
            "Unternehmens-E-Commerce + Werbe-Website",
            "1 Werbevideo pro Monat",
            "2 Model-Auswahlrechte"
          ],
          detailedFeatures: [
            "3 Social-Media-Plattformen (Instagram + TikTok + X)",
            "48 Videos pro Monat",
            "Unternehmens-E-Commerce + Werbe-Website",
            "1 professionelles Werbevideo pro Monat",
            "2 Model-Auswahlrechte",
            "+2 Stunden zusätzlicher Support",
            "Google Ads Management",
            "Meta-Werbung Management",
            "SEO-Einstellungen",
            "Vierteljährliche Leistungsberichte",
            "Fortgeschrittene Hashtag-Strategie",
            "Individuelle Grafikdesigns",
            "Vierteljährliches Strategiemeeting",
            "Jährliche Markenplanung",
            "Wöchentliches Kundengewinnungsgespräch mit Leader (Remote)",
            "Monatliches E-Commerce-Verkaufstraining (Vom Leader)",
            "Krisenkommunikationsmanagement"
          ],
          cta: "Paket wählen"
        },
        fenomen: {
          name: "Influencer",
          price: "150.000 ₺",
          features: [
            "5 Plattformen (YouTube, Instagram, X, TikTok, LinkedIn)",
            "96 Videos pro Monat",
            "Unternehmens-Website + E-Commerce",
            "5 Werbevideos pro Monat",
            "Jedes Model + jede Sprache"
          ],
          detailedFeatures: [
            "5 Social-Media-Plattformen (YouTube, Instagram, X, TikTok, LinkedIn)",
            "96 Videos pro Monat (Reels/Shorts)",
            "Unternehmens-Website + E-Commerce-Site",
            "5 professionelle Werbevideos pro Monat",
            "Jedes Model + jede Sprache Option",
            "24/7 VIP-Support",
            "Hashtag-Recherche (Monatlich)",
            "Wettbewerbsanalyse (Monatlich)",
            "Google Ads Management",
            "Meta-Werbung Management",
            "SEO-Einstellungen",
            "Dedizierter Projektmanager",
            "Persönliche Markenberatung",
            "Influencer-Strategieplanung",
            "Monatliches Strategiemeeting",
            "Jährliche Markenplanung",
            "Leader-Anruf jederzeit während der Geschäftszeiten (Remote)",
            "Wöchentliches E-Commerce-Verkaufstraining (Vom Leader)",
            "Spezielle Event-Unterstützung",
            "Krisenkommunikationsmanagement"
          ],
          cta: "Paket wählen"
        },
        enterprise: {
          name: "Enterprise",
          price: "Individueller Preis",
          features: [
            "4 Plattformen (YouTube, Instagram, X, TikTok)",
            "72 Videos pro Monat",
            "E-Commerce-Site + Individuelle E-Commerce-Site",
            "3 Werbevideos pro Monat",
            "Jedes Model + jede Sprache",
            "24/7 Support"
          ],
          detailedFeatures: [
            "4 Social-Media-Plattformen (YouTube, Instagram, X, TikTok)",
            "72 Videos pro Monat",
            "E-Commerce-Site + Individuelle E-Commerce-Site",
            "3 professionelle Werbevideos pro Monat",
            "Jedes Model + jede Sprache Option",
            "24/7 VIP-Support",
            "Google Ads Management",
            "Meta-Werbung Management",
            "SEO-Einstellungen",
            "Dedizierter Projektmanager",
            "Wettbewerbsanalyse (Monatlich)",
            "Markenstrategieberatung",
            "360° Digitales Marketing",
            "Monatliches Strategiemeeting",
            "Vierteljährliche Markenplanung",
            "Leader-Anruf jederzeit während der Geschäftszeiten (Remote)",
            "Wöchentliches E-Commerce-Verkaufstraining (Vom Leader)",
            "Spezielle Event-Unterstützung",
            "Krisenkommunikationsmanagement"
          ],
          cta: "Kontaktieren Sie uns"
        }
      },
      about: {
        title: "Über uns",
        tagline: "Wachstum, Klarheit und Nachhaltiger Erfolg",
        intro: "Usta Consulting steht für Wachstum, Klarheit und nachhaltigen Erfolg. Wir sind ein strategischer Partner, der Unternehmen hilft, ihr Potenzial zu maximieren.",
        paragraph1: "Mit über 5 Jahren Branchenerfahrung und Beratungsleistungen für mehr als 70 Unternehmen in verschiedenen Ländern wie der Türkei, Deutschland, Litauen, Belgien und den Niederlanden verstehen wir die einzigartigen Dynamiken jeder Branche tiefgreifend.",
        paragraph2: "Bei jeder Zusammenarbeit bieten wir maßgeschneiderte Lösungen für Unternehmen; wir handeln mit einem Fokus auf analytisches Denken, kreative Strategie und langfristigen Erfolg.",
        highlight1: "Vertriebs- und Marketingstrategien",
        highlight2: "Digitalisierung und E-Commerce-Lösungen",
        highlight3: "Unternehmensberatung",
        highlight4: "Social Media und Markenmanagement",
        vision: "Unsere Vision",
        visionText: "Eine führende Organisation zu sein, die Unternehmen auf globaler Ebene leitet und innovative, ergebnisorientierte Beratungsleistungen anbietet.",
        mission: "Unsere Mission",
        missionText: "Unternehmen jeder Größe strategische Lösungen zu bieten, die nachhaltiges Wachstum und dauerhaften Erfolg ermöglichen.",
        closing: "Unser Expertenteam ist bereit, sein Wissen und seine Erfahrung in Vertrieb, Marketing, Digitalisierung und Unternehmensführung zu teilen, um Ihr Unternehmen auf die nächste Stufe zu heben.",
        slogan: "\"Meisterschaft in der Beratung, Partnerschaft im Erfolg.\"",
        stats: {
          clients: "Zufriedene Kunden",
          projects: "Erfolgreiche Projekte",
          countries: "Länder Bedient",
          satisfaction: "Kundenzufriedenheit"
        }
      },
      portfolio: {
        title: "Unser Portfolio",
        subtitle: "Beispiele aus unseren erfolgreichen Projekten",
        viewProject: "Projekt ansehen",
        privacyNotice: "Kundennamen sind gemäß KVKK und DSGVO ausgeblendet.",
        germanyClient: "Unser Kunde in Deutschland",
        reviewsTitle: "Kundenbewertungen",
        reviewsSubtitle: "Meinungen unserer über 70 zufriedenen Kunden",
        projects: {
          crazymobel: {
            title: "Crazy Möbel Outlet",
            category: "E-Commerce & Digitales Marketing",
            desc: "Umfassende digitale Transformation und E-Commerce-Lösungen in der Möbelbranche"
          },
          fablemont: {
            title: "Fablemont Möbel",
            category: "E-Commerce & Markenmanagement",
            desc: "Digitales Marketing und Online-Verkaufsstrategien für Möbelmarke"
          },
          hipotez: {
            title: "Hipotez International",
            category: "Unternehmensberatung & Digitale Lösungen",
            desc: "Internationale Unternehmensberatung und digitale Transformationsdienste"
          },
          vizeeurope: {
            title: "Vize Europe",
            category: "Visum-Beratung & Dienstleistungen",
            desc: "Europäische Visumantragsprozesse und professionelle Beratungsdienste"
          }
        }
      },
      crazyMobel: {
        title: "Crazy Möbel Outlet",
        subtitle: "Digitales Transformationsprojekt für unseren Kunden in Deutschland",
        visitWebsite: "Website besuchen",
        projectScope: "Projektumfang",
        projectScopeDesc: "Wir haben eine umfassende digitale Marketingstrategie für Crazy Möbel Outlet entwickelt. Wir haben alle digitalen Prozesse von E-Commerce-Infrastruktur bis Social Media Management, von Werbeproduktion bis SEO-Arbeit verwaltet.",
        services: "Erbrachte Dienstleistungen",
        service1: "Social Media Management",
        service2: "E-Commerce-Integration",
        service3: "Professionelle Werbeproduktion",
        service4: "Google & Meta Ads Management",
        results: "Erzielte Ergebnisse",
        resultsDesc: "Durch unsere digitalen Marketingbemühungen erzielten wir eine 300%ige Steigerung der Online-Verkäufe, 500% Wachstum der Social-Media-Follower und eine signifikante Steigerung der Markenbekanntheit.",
        videosTitle: "Videos für unseren Kunden in Deutschland",
        videosSubtitle: "Von unserem professionellen Team erstellte Werbevideos"
      },
      team: {
        title: "Unser Team",
        subtitle: "Das professionelle Team hinter unserem Erfolg",
        modelsTitle: "Unsere Models",
        ourTeam: "Unser Team",
        members: {
          m1: {
            name: "Mert Usta",
            role: "Gründer & CEO",
            expertise: "Expertise: Geschäftsentwicklung, Digitales Marketing & Strategie"
          },
          m2: {
            name: "Dilara Yüksekcan",
            role: "Model",
            expertise: ""
          },
          m3: {
            name: "Polina Vladyka",
            role: "Model",
            expertise: ""
          },
          m4: {
            name: "Svenja Patruska",
            role: "Model",
            expertise: ""
          },
          m5: {
            name: "Veronika Kabilya",
            role: "Model",
            expertise: ""
          },
          m6: {
            name: "Caner Toptaş",
            role: "Softwareingenieur",
            expertise: "Expertise: Full-Stack Entwicklung, React, Django, Docker & Moderne Web-Technologien"
          },
          m7: {
            name: "Ayça Ulutaş",
            role: "Model",
            expertise: ""
          }
        }
      },
      blog: {
        title: "Blog",
        subtitle: "Neueste Nachrichten aus der digitalen Welt",
        readMore: "Weiterlesen",
        allPosts: "Alle Beiträge anzeigen",
        search: "Blogbeiträge suchen..."
      },
      contact: {
        title: "Kontakt",
        subtitle: "Nehmen Sie Kontakt mit uns auf",
        name: "Ihr Name",
        email: "E-Mail",
        phone: "Telefon",
        message: "Ihre Nachricht",
        send: "Senden",
        info: "Kontaktinformationen",
        address: "Adresse",
        workingHours: "Öffnungszeiten",
        followUs: "Folgen Sie uns",
        whatsappBtn: "Kontakt über WhatsApp"
      },
      footer: {
        rights: "Alle Rechte vorbehalten.",
        privacy: "Datenschutzrichtlinie",
        terms: "Nutzungsbedingungen",
        desc: "Ihr Partner für digitalen Erfolg. Wir bringen Ihre Marke mit Social Media, E-Commerce und Werbelösungen an die Spitze.",
        quickLinks: "Schnelllinks",
        services: "Dienstleistungen",
        socialMedia: "Social Media Management",
        ecommerce: "E-Commerce Einrichtung",
        adProduction: "Werbeproduktion",
        modelOptions: "Model-Optionen",
        digitalConsulting: "Digitale Beratung",
        location: "Istanbul, Türkei"
      },
      privacy: {
        title: "Datenschutzrichtlinie",
        lastUpdated: "Letzte Aktualisierung",
        section1: {
          title: "1. Gesammelte Informationen",
          content: "Als UstaConsulting sammeln wir bestimmte persönliche Informationen, um unsere Dienstleistungen zu erbringen. Diese Informationen können Name, Nachname, E-Mail-Adresse, Telefonnummer und Unternehmensinformationen umfassen."
        },
        section2: {
          title: "2. Verwendung der Informationen",
          content: "Wir verwenden die gesammelten Informationen, um unsere Dienstleistungen bereitzustellen, Kundensupport anzubieten, Marketingkommunikation zu senden und unsere Dienstleistungen zu verbessern."
        },
        section3: {
          title: "3. Informationssicherheit",
          content: "Wir verwenden branchenübliche Sicherheitsmaßnahmen, um die Sicherheit Ihrer persönlichen Daten zu gewährleisten. Ihre Daten werden über verschlüsselte Verbindungen übertragen und auf sicheren Servern gespeichert."
        },
        section4: {
          title: "4. Cookies",
          content: "Wir verwenden Cookies auf unserer Website, um die Benutzererfahrung zu verbessern. Sie können Cookies in Ihren Browsereinstellungen deaktivieren."
        },
        section5: {
          title: "5. Dritte Parteien",
          content: "Wir geben Ihre persönlichen Daten nicht an Dritte weiter, außer bei rechtlichen Verpflichtungen. Unsere Dienstleister müssen ebenfalls die gleichen Datenschutzstandards einhalten."
        },
        contact: {
          title: "6. Kontakt",
          content: "Bei Fragen zu unserer Datenschutzrichtlinie können Sie uns kontaktieren:"
        }
      },
      terms: {
        title: "Nutzungsbedingungen",
        lastUpdated: "Letzte Aktualisierung",
        section1: {
          title: "1. Servicebedingungen",
          content: "Durch die Nutzung der UstaConsulting-Dienste stimmen Sie diesen Nutzungsbedingungen zu. Unsere Dienstleistungen umfassen digitale Beratung, Social Media Management und E-Commerce-Lösungen für kommerzielle Zwecke."
        },
        section2: {
          title: "2. Benutzerverantwortlichkeiten",
          content: "Benutzer verpflichten sich, unsere Dienste für rechtmäßige Zwecke zu nutzen und genaue Informationen bereitzustellen. Der Dienst kann bei irreführenden oder falschen Informationen ausgesetzt werden."
        },
        section3: {
          title: "3. Zahlungsbedingungen",
          content: "Servicegebühren müssen wie im Vertrag angegeben und innerhalb der angegebenen Zeit bezahlt werden. Bei verspäteten Zahlungen können gesetzliche Zinsen anfallen."
        },
        section4: {
          title: "4. Geistiges Eigentum",
          content: "Alle Inhalte, Designs und Materialien gehören UstaConsulting. Unbefugtes Kopieren oder Verbreiten ist verboten."
        },
        section5: {
          title: "5. Haftungsbeschränkung",
          content: "UstaConsulting garantiert nicht, dass die Dienste unterbrechungs- oder fehlerfrei sind. Wir können nicht für indirekte Schäden verantwortlich gemacht werden."
        },
        contact: {
          title: "6. Kontakt",
          content: "Bei Fragen zu den Nutzungsbedingungen können Sie uns kontaktieren:"
        }
      }
    }
  },
  ru: {
    translation: {
      nav: {
        home: "Главная",
        services: "Услуги",
        packages: "Пакеты",
        about: "О нас",
        portfolio: "Портфолио",
        blog: "Блог",
        contact: "Контакты"
      },
      hero: {
        title: "Консалтинг По-Новому",
        subtitle: "Usta Consulting Помогает Вам Привлекать Новых Клиентов И Поддерживает Цифровизацию Вашего Бизнеса.",
        cta: "Начать",
        packages: "Посмотреть пакеты",
        badge: "Лидер цифровой трансформации",
        trustedBy: "Нам Доверяют Более 70 Клиентов",
        stats: {
          clients: "Довольных клиентов",
          projects: "Проектов",
          experience: "Лет опыта"
        }
      },
      trustBanner: {
        title: "Нам Доверяют Более 70 Клиентов",
        subtitle: "Построить успешный бизнес — это не чудо. Узнайте об опыте наших клиентов.",
        button: "Наши референсы"
      },
      socialStats: {
        title: "Наши подписчики в социальных сетях",
        subtitle: "Подписывайтесь на нас в социальных сетях и открывайте наш контент",
        followers: "Подписчиков",
        likes: "Лайков",
        followUs: "Подписаться",
        note: "Количество подписчиков обновляется в реальном времени"
      },
      videoShowcase: {
        title: "Наши видео",
        subtitle: "Примеры профессионального видеопроизводства",
        ai: "На основе ИИ"
      },
      services: {
        title: "Наши услуги",
        subtitle: "Комплексные решения, чтобы выделить ваш бизнес в цифровом мире",
        social: {
          title: "Управление социальными сетями",
          desc: "Профессиональное создание контента и управление аккаунтами в Instagram, TikTok, LinkedIn, YouTube и всех платформах."
        },
        ecommerce: {
          title: "Настройка и управление электронной коммерцией",
          desc: "Настройка и управление магазинами на Trendyol, Hepsiburada, N11, Amazon TR и всех турецких маркетплейсах."
        },
        ads: {
          title: "Рекламное производство",
          desc: "Представьте свой бренд наилучшим образом с профессиональной видео- и фотосъемкой.",
          features: {
            video: "Видеопроизводство",
            photo: "Фотосъемка",
            drone: "Съемка с дрона",
            studio: "Студийные услуги",
            post: "Постпродакшн",
            animation: "Анимация"
          }
        },
        models: {
          title: "Варианты моделей",
          desc: "Рекламные возможности с моделями, говорящими на разных языках и имеющими различные профили.",
          features: {
            turkish: "Турецкоговорящие",
            english: "Англоговорящие",
            german: "Немецкоговорящие",
            russian: "Русскоговорящие",
            arabic: "Арабоговорящие",
            other: "Другие языки"
          }
        },
        cta: "Получить предложение",
        options: "опции"
      },
      packages: {
        title: "Цены",
        subtitle: "Выберите пакет, соответствующий вашим потребностям",
        monthly: "/ месяц",
        moreDetails: "+ Подробнее",
        detailedTitle: "Детальное сравнение пакетов",
        detailedSubtitle: "Ознакомьтесь со всеми функциями пакетов подробно",
        ecommerce: {
          name: "Электронная коммерция",
          price: "55 000 ₺",
          features: [
            "Управление магазинами Trendyol, Hepsiburada, N11",
            "Оптимизация фото и описаний товаров",
            "SEO для E-Commerce",
            "Ежемесячный отчет о продажах",
            "Google Ads & Meta Ads"
          ],
          detailedFeatures: [
            "Настройка и управление магазинами Trendyol, Hepsiburada, N11",
            "Фотосъемка и оптимизация описаний товаров",
            "Настройка SEO для E-Commerce",
            "Управление Google Ads",
            "Управление Meta рекламой",
            "Ежемесячный отчет о продажах и производительности",
            "Управление листингами и каталогом",
            "Стратегия ценообразования",
            "Отслеживание и управление запасами",
            "Поддержка в рабочее время (10:00-18:00)",
            "Управление кризисными коммуникациями"
          ],
          cta: "Выбрать пакет"
        },
        starter: {
          name: "Стартовый",
          price: "70 000 ₺",
          features: [
            "2 платформы (Instagram + TikTok)",
            "24 видео в месяц",
            "Рекламный веб-сайт",
            "Автоматический выбор модели",
            "Google Ads & Meta Ads"
          ],
          detailedFeatures: [
            "2 платформы социальных сетей (Instagram + TikTok)",
            "24 видео в месяц",
            "Создание рекламного веб-сайта",
            "Автоматический выбор модели",
            "Поддержка в рабочее время",
            "Управление Google Ads",
            "Управление Meta рекламой",
            "Настройки SEO",
            "Ежемесячный отчет о производительности",
            "Исследование хэштегов",
            "Календарь контента",
            "Ежемесячный звонок с лидером по привлечению клиентов (Удаленно)",
            "Управление кризисными коммуникациями"
          ],
          cta: "Выбрать пакет"
        },
        professional: {
          name: "Профессиональный",
          price: "99 000 ₺",
          popular: "Самый популярный",
          features: [
            "3 платформы (Instagram + TikTok + X)",
            "48 видео в месяц",
            "Корпоративный E-Commerce + Рекламный сайт",
            "1 рекламное видео в месяц",
            "2 права выбора модели"
          ],
          detailedFeatures: [
            "3 платформы социальных сетей (Instagram + TikTok + X)",
            "48 видео в месяц",
            "Корпоративный E-Commerce + Рекламный сайт",
            "1 профессиональное рекламное видео в месяц",
            "2 права выбора модели",
            "+2 часа дополнительной поддержки",
            "Управление Google Ads",
            "Управление Meta рекламой",
            "Настройки SEO",
            "Ежеквартальные отчеты о производительности",
            "Продвинутая стратегия хэштегов",
            "Индивидуальный графический дизайн",
            "Ежеквартальная стратегическая встреча",
            "Годовое планирование бренда",
            "Еженедельный звонок с лидером по привлечению клиентов (Удаленно)",
            "Ежемесячное обучение продажам в E-Commerce (От лидера)",
            "Управление кризисными коммуникациями"
          ],
          cta: "Выбрать пакет"
        },
        fenomen: {
          name: "Инфлюенсер",
          price: "150 000 ₺",
          features: [
            "5 платформ (YouTube, Instagram, X, TikTok, LinkedIn)",
            "96 видео в месяц",
            "Корпоративный сайт + E-Commerce",
            "5 рекламных видео в месяц",
            "Любая модель + любой язык"
          ],
          detailedFeatures: [
            "5 платформ социальных сетей (YouTube, Instagram, X, TikTok, LinkedIn)",
            "96 видео в месяц (Reels/Shorts)",
            "Корпоративный сайт + E-Commerce сайт",
            "5 профессиональных рекламных видео в месяц",
            "Любая модель + любой язык на выбор",
            "VIP поддержка 24/7",
            "Исследование хэштегов (Ежемесячно)",
            "Анализ конкурентов (Ежемесячно)",
            "Управление Google Ads",
            "Управление Meta рекламой",
            "Настройки SEO",
            "Персональный менеджер проекта",
            "Консультирование по личному бренду",
            "Планирование стратегии инфлюенсеров",
            "Ежемесячная стратегическая встреча",
            "Годовое планирование бренда",
            "Звонок с лидером в любое время в рабочие часы (Удаленно)",
            "Еженедельное обучение продажам в E-Commerce (От лидера)",
            "Поддержка специальных мероприятий",
            "Управление кризисными коммуникациями"
          ],
          cta: "Выбрать пакет"
        },
        enterprise: {
          name: "Корпоративный",
          price: "Индивидуальная цена",
          features: [
            "4 платформы (YouTube, Instagram, X, TikTok)",
            "72 видео в месяц",
            "E-Commerce сайт + Индивидуальный E-Commerce сайт",
            "3 рекламных видео в месяц",
            "Любая модель + любой язык",
            "Поддержка 24/7"
          ],
          detailedFeatures: [
            "4 платформы социальных сетей (YouTube, Instagram, X, TikTok)",
            "72 видео в месяц",
            "E-Commerce сайт + Индивидуальный E-Commerce сайт",
            "3 профессиональных рекламных видео в месяц",
            "Любая модель + любой язык на выбор",
            "VIP поддержка 24/7",
            "Управление Google Ads",
            "Управление Meta рекламой",
            "Настройки SEO",
            "Персональный менеджер проекта",
            "Анализ конкурентов (Ежемесячно)",
            "Консультирование по стратегии бренда",
            "360° Цифровой маркетинг",
            "Ежемесячная стратегическая встреча",
            "Квартальное планирование бренда",
            "Звонок с лидером в любое время в рабочие часы (Удаленно)",
            "Еженедельное обучение продажам в E-Commerce (От лидера)",
            "Поддержка специальных мероприятий",
            "Управление кризисными коммуникациями"
          ],
          cta: "Связаться с нами"
        }
      },
      about: {
        title: "О нас",
        tagline: "Рост, Ясность и Устойчивый Успех",
        intro: "Usta Consulting олицетворяет рост, ясность и устойчивый успех. Мы являемся стратегическим партнером, помогающим бизнесу максимально раскрыть свой потенциал.",
        paragraph1: "Имея более 5 лет отраслевого опыта и предоставляя консультационные услуги более чем 70 компаниям в разных странах, включая Турцию, Германию, Литву, Бельгию и Нидерланды, мы глубоко понимаем уникальную динамику каждой отрасли.",
        paragraph2: "В каждом сотрудничестве мы предлагаем индивидуальные решения для бизнеса; действуя с акцентом на аналитическое мышление, креативную стратегию и долгосрочный успех.",
        highlight1: "Стратегии продаж и маркетинга",
        highlight2: "Цифровизация и решения электронной коммерции",
        highlight3: "Консалтинг корпоративного управления",
        highlight4: "Социальные сети и управление брендом",
        vision: "Наше видение",
        visionText: "Стать ведущей организацией, которая направляет бизнес в глобальном масштабе, предлагая инновационные и ориентированные на результат консалтинговые услуги.",
        mission: "Наша миссия",
        missionText: "Предоставлять стратегические решения предприятиям любого размера, позволяя им достигать устойчивого роста и долгосрочного успеха.",
        closing: "Наша команда экспертов готова поделиться своими знаниями и опытом в области продаж, маркетинга, цифровизации и корпоративного управления, чтобы вывести ваш бизнес на новый уровень.",
        slogan: "\"Мастерство в консалтинге, партнерство в успехе.\"",
        stats: {
          clients: "Довольных клиентов",
          projects: "Успешных проектов",
          countries: "Стран Обслужено",
          satisfaction: "Удовлетворенность клиентов"
        }
      },
      portfolio: {
        title: "Наше портфолио",
        subtitle: "Примеры наших успешных проектов",
        viewProject: "Посмотреть проект",
        privacyNotice: "Имена клиентов скрыты в соответствии с KVKK и GDPR.",
        germanyClient: "Наш клиент в Германии",
        reviewsTitle: "Отзывы клиентов",
        reviewsSubtitle: "Мнения наших более 70 довольных клиентов",
        projects: {
          crazymobel: {
            title: "Crazy Möbel Outlet",
            category: "Электронная коммерция и Цифровой маркетинг",
            desc: "Комплексная цифровая трансформация и решения электронной коммерции в мебельной индустрии"
          },
          fablemont: {
            title: "Fablemont Мебель",
            category: "Электронная коммерция и Управление брендом",
            desc: "Цифровой маркетинг и стратегии онлайн-продаж для мебельного бренда"
          },
          hipotez: {
            title: "Hipotez International",
            category: "Корпоративный консалтинг и Цифровые решения",
            desc: "Международный корпоративный консалтинг и услуги цифровой трансформации"
          },
          vizeeurope: {
            title: "Vize Europe",
            category: "Визовый консалтинг и Услуги",
            desc: "Процессы подачи заявлений на европейскую визу и профессиональные консультационные услуги"
          }
        }
      },
      crazyMobel: {
        title: "Crazy Möbel Outlet",
        subtitle: "Проект цифровой трансформации для нашего клиента в Германии",
        visitWebsite: "Посетить сайт",
        projectScope: "Объем проекта",
        projectScopeDesc: "Мы разработали комплексную стратегию цифрового маркетинга для Crazy Möbel Outlet. Мы управляли всеми цифровыми процессами от инфраструктуры электронной коммерции до управления социальными сетями, от рекламного производства до SEO-работ.",
        services: "Предоставленные услуги",
        service1: "Управление социальными сетями",
        service2: "Интеграция электронной коммерции",
        service3: "Профессиональное рекламное производство",
        service4: "Управление Google & Meta рекламой",
        results: "Достигнутые результаты",
        resultsDesc: "В результате наших усилий по цифровому маркетингу мы добились 300% роста онлайн-продаж, 500% роста подписчиков в социальных сетях и значительного повышения узнаваемости бренда.",
        videosTitle: "Видео для нашего клиента в Германии",
        videosSubtitle: "Рекламные видео, подготовленные нашей профессиональной командой"
      },
      team: {
        title: "Наша команда",
        subtitle: "Профессиональная команда за нашим успехом",
        modelsTitle: "Наши модели",
        ourTeam: "Наша команда",
        members: {
          m1: {
            name: "Мерт Уста",
            role: "Основатель и CEO",
            expertise: "Экспертиза: Развитие бизнеса, Цифровой маркетинг и Стратегия"
          },
          m2: {
            name: "Дилара Йюксекджан",
            role: "Модель",
            expertise: ""
          },
          m3: {
            name: "Полина Владыка",
            role: "Модель",
            expertise: ""
          },
          m4: {
            name: "Свенья Патруска",
            role: "Модель",
            expertise: ""
          },
          m5: {
            name: "Вероника Кабилья",
            role: "Модель",
            expertise: ""
          },
          m6: {
            name: "Caner Toptaş",
            role: "Инженер-программист",
            expertise: "Экспертиза: Full-Stack разработка, React, Django, Docker и современные веб-технологии"
          },
          m7: {
            name: "Айча Улуташ",
            role: "Модель",
            expertise: ""
          }
        }
      },
      blog: {
        title: "Блог",
        subtitle: "Последние новости из цифрового мира",
        readMore: "Читать далее",
        allPosts: "Посмотреть все статьи",
        search: "Поиск статей..."
      },
      contact: {
        title: "Контакты",
        subtitle: "Свяжитесь с нами",
        name: "Ваше имя",
        email: "Электронная почта",
        phone: "Телефон",
        message: "Ваше сообщение",
        send: "Отправить",
        info: "Контактная информация",
        address: "Адрес",
        workingHours: "Рабочие часы",
        followUs: "Подписывайтесь на нас",
        whatsappBtn: "Связаться через WhatsApp"
      },
      footer: {
        rights: "Все права защищены.",
        privacy: "Политика конфиденциальности",
        terms: "Условия использования",
        desc: "Ваш партнер в цифровом успехе. Мы выводим ваш бренд на вершину с помощью социальных сетей, электронной коммерции и рекламных решений.",
        quickLinks: "Быстрые ссылки",
        services: "Услуги",
        socialMedia: "Управление социальными сетями",
        ecommerce: "Настройка электронной коммерции",
        adProduction: "Рекламное производство",
        modelOptions: "Варианты моделей",
        digitalConsulting: "Цифровой консалтинг",
        location: "Стамбул, Турция"
      },
      privacy: {
        title: "Политика конфиденциальности",
        lastUpdated: "Последнее обновление",
        section1: {
          title: "1. Собираемая информация",
          content: "Как UstaConsulting, мы собираем определенную личную информацию для предоставления наших услуг. Эта информация может включать имя, фамилию, адрес электронной почты, номер телефона и информацию о компании."
        },
        section2: {
          title: "2. Использование информации",
          content: "Мы используем собранную информацию для предоставления наших услуг, поддержки клиентов, отправки маркетинговых сообщений и улучшения наших услуг."
        },
        section3: {
          title: "3. Безопасность информации",
          content: "Мы используем стандартные отраслевые меры безопасности для обеспечения безопасности вашей личной информации. Ваши данные передаются по зашифрованным соединениям и хранятся на защищенных серверах."
        },
        section4: {
          title: "4. Файлы cookie",
          content: "Мы используем файлы cookie на нашем веб-сайте для улучшения пользовательского опыта. Вы можете отключить файлы cookie в настройках браузера."
        },
        section5: {
          title: "5. Третьи стороны",
          content: "Мы не передаем вашу личную информацию третьим лицам, за исключением юридических обязательств. Наши поставщики услуг также должны соблюдать те же стандарты конфиденциальности."
        },
        contact: {
          title: "6. Контакты",
          content: "По вопросам о нашей политике конфиденциальности вы можете связаться с нами:"
        }
      },
      terms: {
        title: "Условия использования",
        lastUpdated: "Последнее обновление",
        section1: {
          title: "1. Условия обслуживания",
          content: "Используя услуги UstaConsulting, вы соглашаетесь с этими условиями использования. Наши услуги включают цифровой консалтинг, управление социальными сетями и решения для электронной коммерции для коммерческих целей."
        },
        section2: {
          title: "2. Обязанности пользователя",
          content: "Пользователи соглашаются использовать наши услуги в законных целях и предоставлять точную информацию. Услуга может быть приостановлена в случае вводящей в заблуждение или ложной информации."
        },
        section3: {
          title: "3. Условия оплаты",
          content: "Плата за услуги должна быть оплачена в соответствии с договором и в указанные сроки. За просрочку платежа могут начисляться законные проценты."
        },
        section4: {
          title: "4. Интеллектуальная собственность",
          content: "Весь контент, дизайн и материалы принадлежат UstaConsulting. Несанкционированное копирование или распространение запрещено."
        },
        section5: {
          title: "5. Ограничение ответственности",
          content: "UstaConsulting не гарантирует, что услуги будут бесперебойными или безошибочными. Мы не несем ответственности за косвенные убытки."
        },
        contact: {
          title: "6. Контакты",
          content: "По вопросам об условиях использования вы можете связаться с нами:"
        }
      }
    }
  }
};
